
  import { Component, Vue } from 'vue-property-decorator';
  import { courseSelectData, courseType } from '@/static/data/course';
  import { AppModule } from '@/store/modules/app';
  import { isMobile } from '@/utils/validate';
  
  
  interface PaginationFilter<T = any> {
    totalResult: number,
    currentPage: number,
    showCount: number,
    totalPage: number
  }
  
  @Component({
    name: 'course',
  })
  export default class extends Vue {
    public courseList: any[] = [];
    public courseTypeList: any[] = [];
    public searchKeyword: string = '';
    public selectCourseType: string = '';
    public dataPagination: PaginationFilter<any> = {
      totalResult: 0,
      currentPage: 1,
      showCount: 10,
      totalPage: 1
    };
    public searchFilterList: any = []; // 搜索筛选出来的数据
  
    get isMobile() {
      return isMobile();
    }
    get langEN() {
        if (AppModule.language === 'en-us') {
            return true;
        } else {
            return false;
        }
    }
    public created() {
      this.searchFilterList = [...courseSelectData];
      this.getList();
      this.courseTypeList = courseType;
    }
    public goCourse(item: any) {
      window.location.href = "../course/" + item.id;
    }
    public handleCurrentChange(currentPage: number) {
      this.dataPagination.currentPage = currentPage;
      this.getList();
    }
  
    public handleSizeChange(pageSize: number) {
      this.dataPagination.showCount = pageSize;
      this.getList();
    }
    public handleChangeKeyword(val: string) {
      this.handleSearchKeyword();
    }
    public async handleSearchKeyword() {
      this.courseList = courseSelectData.filter((v: any) => v.title.toLowerCase().match(this.searchKeyword.toLowerCase()));
    }
    public async handleSearch() {
      const index = this.courseTypeList.findIndex((item: any) => String(item.id) ===String(this.selectCourseType));
      if(index > -1 && this.courseTypeList[index].key) {
        const key = this.courseTypeList[index].key;
        this.searchFilterList = courseSelectData.filter((v: any) => v[key] === 'Y');
      }else {
        this.searchFilterList = [...courseSelectData];
      }
      this.dataPagination.currentPage = 1;
      this.getList();
    }
    // 获取当前的列表数据
    public getList() {
      const pageDatas: any = [];
      for(let i = 0; i < this.searchFilterList.length; i+= this.dataPagination.showCount) {
        const pagedata = this.searchFilterList.slice(i, i + this.dataPagination.showCount);
        pageDatas.push(pagedata);
      }
      this.courseList = pageDatas[this.dataPagination.currentPage - 1];
      this.dataPagination.totalPage = Math.ceil(this.dataPagination.totalResult / this.dataPagination.showCount);
      this.dataPagination.totalResult = this.searchFilterList.length;
    }
    public goSampleLessonAll() {
      window.location.href = '../sampleLesson';
    }
    public goSampleLesson(item: any) {
      window.location.href = "../sampleLesson/" + item.id;
    }
  }
  